import MainCtl from './main/MainCtl';
import MixMapCtl from '@/page/mainPage/map/mixmap/MixMapCtl';

function createModule() {
    const MixMapModule = new MixMapCtl({
        talksE: false,
        showSearch: false,
    }).init();
    const MainModule = new MainCtl(MixMapModule).init();

    MainModule.input.map.push(MixMapModule.output.default);
    MixMapModule.input.mapView.push(MainModule.output.search);
    MixMapModule.input.map2dContent.push(MainModule.output.HivesPoints);
    return {
        MainModule,
    };
}

export default createModule;
